<template>
    <Modal v-if="show" size="large" @hide="modalWarningShow = true">
        <i class="onboarding-tour__header--sec">{{ heading }}</i>
        <OnboardingTourStep
            :header="steps[stepNr].header"
            :text="steps[stepNr].text"
            :img="steps[stepNr].img"
            :tips="steps[stepNr]?.tips"
        />
        <div class="onboarding-tour__footer">
            <span> {{ stepNr + 1 }} av {{ steps.length }} </span>
            <div class="onboarding-tour__footer-btns">
                <button v-if="stepNr !== steps.length - 1" class="btn btn--txt" @click="modalWarningShow = true">
                    Hoppa över snabbguide
                </button>
                <button class="btn btn--cta" @click="handleNextStep">
                    {{ stepNr === steps.length - 1 ? 'Klart' : 'Nästa' }}
                </button>
            </div>
        </div>
    </Modal>

    <modal v-if="modalWarningShow" animation="slideDown" class-name="modal--info" @hide="modalWarningShow = false">
        <div class="modal-child">
            <h2 class="modal-child__title">Avsluta guiden</h2>
            <p class="modal-child__text">Är du säker att du vill avsluta guiden?</p>
            <div class="modal-child__actions">
                <button class="btn btn--txt" @click="modalWarningShow = false">Avbryt</button>
                <button class="btn btn--cta" @click="handleShowModal">Avsluta</button>
            </div>
        </div>
    </modal>
</template>

<script>
    import { ref, computed } from 'vue';
    import { useStore } from 'vuex';
    import Modal from '@components/Modal/Modal.vue';
    import OnboardingTourStep from '@components/Employ/Onboarding/Modal/NewFeatureTourStep.vue';

    export default {
        components: {
            Modal,
            OnboardingTourStep,
        },
        props: {
            type: {
                type: String,
                required: true,
            },
            heading: {
                type: String,
                required: true,
            },
            steps: {
                type: Array,
                required: true,
            },
            showModal: {
                type: Boolean,
                required: false,
            },
        },
        emits: ['close'],
        setup(props, { emit }) {
            const store = useStore();

            const stepNr = ref(0);
            const show = computed(() => props.showModal);
            const modalWarningShow = ref(false);

            const handleShowModal = () => {
                const successful = store.dispatch('UserStore/SET_ONBOARDING_STATUS', {
                    type: props.type,
                    status: true,
                });

                if (!successful) return;

                modalWarningShow.value = false;
                emit('close', false);
            };

            const handleNextStep = () => {
                if (stepNr.value + 1 === props.steps.length) {
                    handleShowModal();
                    return;
                }

                stepNr.value++;
            };

            return {
                stepNr,
                show,
                modalWarningShow,
                handleNextStep,
                handleShowModal,
            };
        },
    };
</script>
